"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegistrationSearchParameters = exports.ReturnRoutePathnames = exports.RoutePathname = void 0;
var RoutePathname;
(function (RoutePathname) {
    RoutePathname["FAST_CHECKOUT"] = "fastCheckout";
    RoutePathname["DELIVERY"] = "delivery";
    RoutePathname["PAYMENT"] = "payment";
    RoutePathname["CONFIRMATION"] = "confirmation";
    RoutePathname["REGISTRATION"] = "registration";
})(RoutePathname || (exports.RoutePathname = RoutePathname = {}));
var ReturnRoutePathnames;
(function (ReturnRoutePathnames) {
    ReturnRoutePathnames["REGISTERED_RETURNS"] = "registered-returns";
    ReturnRoutePathnames["RETURN_ITEMS"] = "return-items";
})(ReturnRoutePathnames || (exports.ReturnRoutePathnames = ReturnRoutePathnames = {}));
var RegistrationSearchParameters;
(function (RegistrationSearchParameters) {
    RegistrationSearchParameters["EMAIL"] = "email";
    RegistrationSearchParameters["CALLBACK_URL"] = "callbackUrl";
})(RegistrationSearchParameters || (exports.RegistrationSearchParameters = RegistrationSearchParameters = {}));
//# sourceMappingURL=RoutingEnums.js.map